import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { RSM_URL } from "@util/constant";

/**
 * Component to render RSM section on Partners page
 */
const RSMSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="rsm-section-component">
      <AccordionV2
        testId="rsm"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader title="RSM" className="px-0" />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            RSM is the sixth largest audit, tax and consulting network globally,
            with 800 offices across 120 countries. In Singapore, we are the
            largest outside the Big 4, supporting businesses from SMEs to large
            enterprises, in their compliance and back-end functions in
            Accounting & Finance, HR & Payroll, IT Management, Corporate
            Secretarial, as well as Staffing and Recruitment. We help companies
            improve profits, enhance value and internationalise.
          </p>

          <p>
            With a staff strength of more than 950 in Singapore and 320 in
            China, we also help businesses in risk management, corporate
            governance, tax planning, valuation, M&A and other corporate
            advisory work.
          </p>

          <p>
            Visit us at:&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={RSM_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.rsmsingapore.sg
            </a>
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default RSMSection;
